import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { MemberOrganizationInfoModel } from '../models/member-organization-info.model';

@Injectable({
  providedIn: 'root',
})
export class DataService {
  private previousUrl: string;
  private memberInfo$ = new BehaviorSubject<MemberOrganizationInfoModel | undefined>(undefined);
  selectedMemberInfo$ = this.memberInfo$.asObservable();

  private organizationID$ = new BehaviorSubject<string>('');
  selectedOrganizationID$ = this.organizationID$.asObservable();

  constructor(private router: Router) {
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
      if (event.url !== '/login') {
        this.previousUrl = event.url;
      }
    });
  }

  setOrganizationId(organizationID: any) {
    this.organizationID$.next(organizationID);
  }

  setInfo(memberInfo: any) {
    this.memberInfo$.next(memberInfo);
  }

  getPreviousUrl() {
    return this.previousUrl;
  }
}
